import { VuexModule, Module, Mutation, MutationAction } from 'vuex-module-decorators'
import groupBy from "lodash.groupby"
import sortBy from "lodash.sortby"
import FormattedDate from "@/models/FormattedDate"
import InterestArea from "@/models/InterestArea"
import ParentSession from "@/models/ParentSession"
import Session from "@/models/Session"
import Study from "@/models/Study"
import Event from "@/models/Event"
import moment from "moment"
import Building from "../models/Building"
import StudyType from "@/models/StudyType"
import StudyForm from "@/models/StudyForm"
import GenericFilter from "@/models/GenericFilter"
import PortalProcessing from "@/models/PortalProcessing"
import StudyLanguage from "../models/StudyLanguage"
import Params from "@/models/Params"
import Audience from '@/models/Audience'
import { extendMoment } from 'moment-range'
import * as sessiondate_helper from "@/helpers/sessiondate_helper"
import * as sessionfilter_helper from "@/helpers/sessionfilter_helper"
import Subject from '@/models/Subject'

// See: https://championswimmer.in/vuex-module-decorators/pages/installation.html

@Module({ namespaced: true })
export default class EventRegistrationModule extends VuexModule {
  eventId: string | null = null;
  loading = true;
  loadingSessions = true;
  SessionsFullyLoaded = false;
  loadingError = false;
  loadingMessage = "";
  sessionsOnPage = 10;
  portalProcessing: PortalProcessing | null = null;
  event: Event = {
    id: "",
    name: "Loading",
    description: "",
    image: "empty",
    maxSessionRegistrations: 99,
    stopwebsiteregistrationson: new Date(),
    setregistrationsenddate: false,
    websitemessage: "",
    nrOfSesions: 0,
    eventtype: "",
    maxgroepsregistratie: 1
  };
  interestAreas: InterestArea[] = [];
  parentSessions: ParentSession[] = [];
  filterdParentSessions: ParentSession[] = [];
  sessions: Session[] = [];
  studies: Study[] = [];
  studyTypes: StudyType[] = [];
  studyForms: StudyForm[] = [];
  subjects: Subject[] = [];
  studyLanguages: StudyLanguage[] = [];
  dateOfSessions: FormattedDate[] = [];
  buildings: Building[] = [];
  audiences: Audience[] = [];

  audiencesById: { [id: string]: Audience } = {};
  buildingsById: { [id: string]: Building } = {};
  interestAreasById: { [id: string]: InterestArea } = {};
  parentSessionsById: { [id: string]: ParentSession } = {};
  sessionsById: { [id: string]: Session } = {};
  studiesById: { [id: string]: Study } = {};
  studyTypesById: { [id: string]: StudyType } = {};
  studyFormsById: { [id: string]: StudyForm } = {};
  subjectsById: { [id: string]: Subject } = {};
  studyLanguagesById: { [id: string]: StudyLanguage } = {};
  allFilteredSessions: Session[] = [];
  choossenGroepsGrootte: number = 1;

  filters: {
    GroepsGrootte: number;
    VlsCode: string;
    InterestAreas: string[];
    Audiences: string[];
    Buildings: string[];
    SessionDates: number[];
    StudyLanguages: string[];
    StudyTypes: string[];
    StudyForms: string[];
    Subjects: string[];
  } = {
      GroepsGrootte: 0,
      VlsCode: "",
      InterestAreas: [],
      Audiences: [],
      Buildings: [],
      SessionDates: [],
      StudyLanguages: [],
      StudyTypes: [],
      StudyForms: [],
      Subjects: []
    };
  selectedSessions: string[] = [];
  searchString = "";

  get Event() {
    return this.event;
  }

  get VlsSessions() {
    return this.parentSessions.filter(s => s.vlsCode == this.filters.VlsCode && this.filterdParentSessions.filter(p => s.id == p.id).length > 0);
  }

  get IsVlsSession() {
    return (parentSessionId: string) => {
      return (
        this.parentSessions.filter(
          s => this.filters.VlsCode.length > 0 && s.vlsCode == this.filters.VlsCode && s.id == parentSessionId
        ).length > 0
      );
    };
  }

  get studyLanguagesByName() {
    return sortBy(this.studyLanguages, ["name"]);
  }

  get dateOfSessionsByDate() {
    return this.dateOfSessions.sort((a, b) =>
      a.value > b.value ? 1 : a.value < b.value ? -1 : 0
    );
  }

  get buildingsByName() {
    return sortBy(this.buildings, ["name"]);
  }

  get interestAreasByName() {
    return sortBy(this.interestAreas, ["name"]);
  }

  get studyTypesByName() {
    return sortBy(this.studyTypes, ["name"]);
  }

  get studyFormsByName() {
    return sortBy(this.studyForms, ["name"]);
  }

  get subjectsByName() {
    return sortBy(this.subjects, ["name"]);
  }

  get audiencesByName() {
    return sortBy(this.audiences, ["name"]);
  }

  get CurrentNumberOfPages() {

    return Math.ceil(this.filterdParentSessions.length / this.sessionsOnPage);
  }

  get FilterdParentSessionsCount() {
    let total = 0;
    this.filterdParentSessions.filter(
      x => (total += this.FilteredSessions(x.id).length)
    );
    return total;
  }

  get parentSessionsByName() {
    return sortBy(this.parentSessions, ["name"]);
  }

  get sessionsByParentSession() {
    return groupBy(
      this.sessions,
      (session: Session) => session.parentSession?.id
    );
  }

  get hasFiltersSelected() {
    return (
      this.filters.InterestAreas.length > 0 ||
      this.filters.Buildings.length > 0 ||
      this.filters.SessionDates.length > 0 ||
      this.filters.Subjects.length > 0 ||
      this.filters.StudyLanguages.length > 0 ||
      this.filters.StudyForms.length > 0 ||
      this.filters.StudyTypes.length > 0 ||
      this.filters.Audiences.length > 0
    );
  }

  get SessionDatesLength() {
    return this.dateOfSessions.length;
  }

  get activeFilters() {
    const active: GenericFilter[] = [];

    this.filters.InterestAreas.forEach(x => {
      const area = this.interestAreasById[x];
      active.push({
        name: area.name,
        id: x,
        count: area.count,
        group: "InterestAreas"
      } as GenericFilter);
    });

    this.filters.Buildings.forEach(x => {
      const area = this.buildingsById[x];
      active.push({
        name: area.name,
        id: x,
        count: area.count,
        group: "Buildings"
      } as GenericFilter);
    });

    this.filters.Audiences.forEach(x => {
      const area = this.audiencesById[x];
      active.push({
        name: area.name,
        id: x,
        count: area.count,
        group: "Audiences"
      } as GenericFilter);
    });

    this.filters.SessionDates.forEach(x => {
      const area = this.dateOfSessions.find(
        item => item.id === x
      ) as FormattedDate;
      active.push({
        name: area.formatted,
        id: x.toString(),
        count: area.count,
        group: "SessionDates"
      } as GenericFilter);
    });

    const languages = this.studyLanguages;
    this.filters.StudyLanguages.forEach(x => {
      const area = languages.filter(l => l.id == x)[0];
      active.push({
        name: area.name,
        id: x,
        count: area.count,
        group: "StudyLanguages"
      } as GenericFilter);
    });

    this.filters.StudyTypes.forEach(x => {
      const area = this.studyTypesById[x];
      active.push({
        name: area.name,
        id: x,
        count: area.count,
        group: "StudyTypes"
      } as GenericFilter);
    });

    //no
    this.filters.StudyForms.forEach(x => {
      const area = this.studyFormsById[x];
      active.push({
        name: area.name,
        id: x,
        count: area.count,
        group: "StudyForms"
      } as GenericFilter);
    });

    return active;
  }

  get FilteredSessions() {
    return (parentSessionId: string) => {
      if (!this.sessionsByParentSession[parentSessionId]) {
        const emptySessions: Session[] = [];
        return emptySessions;
      }

      return this.sessionsByParentSession[parentSessionId]
        .filter((session: Session) => {
          return sessionfilter_helper.SessionInfilter(session, this.searchString, this.event.eventtype, this.filters);
        })
        .sort(function (a, b) {
          const aConcat = ("0000" + a.groupcode).slice(-5) + a.wachtlijst + (a.withoutDate).toString() + a.start + a.name;
          const bConcat = ("0000" + b.groupcode).slice(-5) + b.wachtlijst + (b.withoutDate).toString() + b.start + b.name;

          if (aConcat > bConcat) {
            return 1;
          } else if (aConcat < bConcat) {
            return -1;
          } else {
            return 0;
          }
        });
    };
  }

  @Mutation
  async vlsChanged(value: string) {
    this.filters.VlsCode = value;
  }

  @Mutation
  async setFilter() {
    const sessionsByParentSession = groupBy(
      this.sessions,
      (session: Session) => session.parentSession?.id
    );

    this.allFilteredSessions = [];
    this.filterdParentSessions = this.parentSessions
      .filter(p => this.sessions.filter(s => s.parentSession?.id == p.id).length > 0)
      .filter(
        p =>
          sessionsByParentSession[p.id].filter((session: Session) => {
            const result = sessionfilter_helper.SessionInfilter(session, this.searchString, this.event.eventtype, this.filters);
            if (result) {
              this.allFilteredSessions.push(session);
            }
            return result;
          }).length > 0
      ).sort((a, b) => {
        const aConcat = a.sortOrder + a.name;
        const bConcat = b.sortOrder + b.name;

        if (aConcat > bConcat) {
          return 1;
        } else if (aConcat < bConcat) {
          return -1;
        } else {
          return 0;
        }
      });

    this.subjects.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.subject?.id == x.id
      ).length)
    );
    this.studyTypes.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.studytype?.id == x.id
      ).length)
    );
    this.studyForms.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.studyform?.id == x.id
      ).length)
    );
    this.interestAreas.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => {
          let infilter = false;
          if (s.interestAreas && s.interestAreas.length > 0) {

            s.interestAreas.forEach(element => {
              if (!infilter && element.id == x.id)
                infilter = true;

            });
          }
          return infilter;
        }
      ).length)
    );
    this.buildings.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.building.id == x.id
      ).length)
    );

    this.audiences.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.audience && s.audience.id == x.id
      ).length)
    );

    this.studyLanguages.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(s => {
        if (x.name == "Nederlands") {
          if (s.parentSession) return s.parentSession.nederlands == "true";
          return false;
        } else if (x.name == "Engels") {
          if (s.parentSession) return s.parentSession.engels == "true";
          return false;
        } else if (x.name == "Duits") {
          if (s.parentSession) return s.parentSession.duits == "true";
          return false;
        }
      }).length)
    );

    this.dateOfSessions.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(s => {
        const sessionStartDate = new Date(s.start);
        const dateId = sessiondate_helper.CalcDateID(sessionStartDate, this.event.eventtype);
        if (s.withoutDate)
          return x.id == 100000000;
        else
          return x.id == dateId && !s.withoutDate;
      }).length)
    );
  }

  @Mutation
  async searchChanged({ value }: { value: string }) {
    this.searchString = value;

    const sessionsByParentSession = groupBy(
      this.sessions,
      (session: Session) => session.parentSession?.id
    );

    this.allFilteredSessions = [];
    this.filterdParentSessions = this.parentSessions
      .filter(p => this.sessions.filter(s => s.parentSession?.id == p.id).length > 0)
      .filter(
        p =>
          sessionsByParentSession[p.id].filter((session: Session) => {
            const result = sessionfilter_helper.SessionInfilter(session, this.searchString, this.event.eventtype, this.filters);
            if (result) {
              this.allFilteredSessions.push(session);
            }
            return result;
          }).length > 0
      ).sort((a, b) => {
        const aConcat = a.sortOrder + a.name;
        const bConcat = b.sortOrder + b.name;

        if (aConcat > bConcat) {
          return 1;
        } else if (aConcat < bConcat) {
          return -1;
        } else {
          return 0;
        }
      });

    this.subjects.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.subject?.id == x.id
      ).length)
    );
    this.studyTypes.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.studytype?.id == x.id
      ).length)
    );
    this.studyForms.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.studyform?.id == x.id
      ).length)
    );
    this.interestAreas.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => {
          let infilter = false;
          if (s.interestAreas && s.interestAreas.length > 0) {

            s.interestAreas.forEach(element => {
              if (!infilter && element.id == x.id)
                infilter = true;

            });
          }
          return infilter;
        }
      ).length)
    );
    this.buildings.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.building.id == x.id
      ).length)
    );

    this.audiences.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.audience && s.audience.id == x.id
      ).length)
    );

    this.studyLanguages.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(s => {
        if (x.name == "Nederlands") {
          if (s.parentSession) return s.parentSession.nederlands == "true";
          return false;
        } else if (x.name == "Engels") {
          if (s.parentSession) return s.parentSession.engels == "true";
          return false;
        } else if (x.name == "Duits") {
          if (s.parentSession) return s.parentSession.duits == "true";
          return false;
        }
      }).length)
    );

    this.dateOfSessions.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(s => {
        const sessionStartDate = new Date(s.start);
        const dateId = sessiondate_helper.CalcDateID(sessionStartDate, this.event.eventtype);
        if (s.withoutDate)
          return x.id == 100000000;
        else
          return x.id == dateId && !s.withoutDate;
      }).length)
    );
  }

  @Mutation
  async filterChanged({ type, values }: { type: string; values: string[] }) {
    this.filters = Object.assign(this.filters, { [type]: values });

    const sessionsByParentSession = groupBy(
      this.sessions,
      (session: Session) => session.parentSession?.id
    );

    this.allFilteredSessions = [];
    this.filterdParentSessions = this.parentSessions
      .filter(p => this.sessions.filter(s => s.parentSession?.id == p.id).length > 0)
      .filter(
        p =>
          sessionsByParentSession[p.id].filter((session: Session) => {
            const result = sessionfilter_helper.SessionInfilter(session, this.searchString, this.event.eventtype, this.filters);
            if (result) {
              this.allFilteredSessions.push(session);
            }
            return result;
          }).length > 0
      ).sort((a, b) => {
        const aConcat = a.sortOrder + a.name;
        const bConcat = b.sortOrder + b.name;

        if (aConcat > bConcat) {
          return 1;
        } else if (aConcat < bConcat) {
          return -1;
        } else {
          return 0;
        }
      });
  }

  @Mutation
  async recalculateFilters() {

    this.subjects.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.subject?.id == x.id
      ).length)
    );
    this.studyTypes.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.studytype?.id == x.id
      ).length)
    );
    this.studyForms.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.studyform?.id == x.id
      ).length)
    );
    this.interestAreas.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => {
          let infilter = false;
          if (s.interestAreas && s.interestAreas.length > 0) {

            s.interestAreas.forEach(element => {
              if (!infilter && element.id == x.id)
                infilter = true;

            });
          }
          return infilter;
        }
      ).length)
    );
    this.buildings.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.building.id == x.id
      ).length)
    );

    this.audiences.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(
        s => s.audience && s.audience.id == x.id
      ).length)
    );

    this.studyLanguages.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(s => {
        if (x.name == "Nederlands") {
          if (s.parentSession) return s.parentSession.nederlands == "true";
          return false;
        } else if (x.name == "Engels") {
          if (s.parentSession) return s.parentSession.engels == "true";
          return false;
        } else if (x.name == "Duits") {
          if (s.parentSession) return s.parentSession.duits == "true";
          return false;
        }
      }).length)
    );

    this.dateOfSessions.forEach(
      x =>
      (x.count = this.allFilteredSessions.filter(s => {
        const sessionStartDate = new Date(s.start);
        const dateId = sessiondate_helper.CalcDateID(sessionStartDate, this.event.eventtype);
        if (s.withoutDate)
          return x.id == 100000000;
        else
          return x.id == dateId && !s.withoutDate;
      }).length)
    );
  }

  @Mutation
  async changeSelection({ id, selected }: { id: string; selected: boolean }) {
    if (selected) {
      if (this.selectedSessions.indexOf(id) === -1)
        this.selectedSessions = [...this.selectedSessions, id];
    } else {
      this.selectedSessions = [...this.selectedSessions.filter(s => s !== id)];
    }

    const sessionGuidsInput = document.getElementById(
      "han_sessieguids"
    ) as HTMLInputElement;
    if (sessionGuidsInput) {
      sessionGuidsInput.value = this.selectedSessions.join(",");
    }

    const eventGuidInput = document.getElementById(
      "han_gebeurtenisguid"
    ) as HTMLInputElement;
    if (eventGuidInput) {
      eventGuidInput.value = this.eventId || "";
    }
  }

  @Mutation
  async loadPortalProcessingData(Id: string | null) {
    const response = await fetch(`./api/GetPortalProcessingData/?id=${Id}`);
    const data: PortalProcessing = await response.json();
    this.portalProcessing = data;
    if (data) {
      this.selectedSessions = this.portalProcessing.sessieGuids;
    }
  }

  @MutationAction
  async loadInitialData(input: Params) {
    if (!input.eventId && !input.ppId) return {};

    let eventId: string = input.eventId;
    let portalProcessing: PortalProcessing | null = null;

    if (input.ppId) {
      const ppResponse = await fetch(
        `./api/GetPortalProcessingData/?id=${input.ppId}`
      );
      const ppData: PortalProcessing = await ppResponse.json();
      portalProcessing = ppData;
      eventId = portalProcessing.eventId;
    }
    // Get the session data
    const response = await fetch(
      `./api/GetEventData/?id=${eventId}`
    );
    const {
      event,
      data
    }: {
      event: Event;
      data: Session[];
    } = await response.json();

    document.title = event.name + " - HAN University of Applied Sciences";

    return {
      eventId,
      loading: false,
      loadingSessions: true,
      portalProcessing,
      event
    };
  }

  @MutationAction
  async loadSessionData(input: Params) {
    if (!input.eventId && !input.ppId) return {};

    let eventId: string = input.eventId;
    let portalProcessing: PortalProcessing | null = null;
    const audiences: Audience[] = [];
    const buildings: Building[] = [];
    const interestAreas: InterestArea[] = [];
    const parentSessions: ParentSession[] = [];
    const filterdParentSessions: ParentSession[] = [];
    const sessions: Session[] = [];
    const studies: Study[] = [];
    const studyTypes: StudyType[] = [];
    const studyForms: StudyForm[] = [];
    const subjects: Subject[] = [];
    const studyLanguages: StudyLanguage[] = [];
    const dateOfSessions: FormattedDate[] = [];
    const dateOfSessionsById: { [id: string]: FormattedDate } = {};
    const audiencesById: { [id: string]: Audience } = {};
    const buildingsById: { [id: string]: Building } = {};
    const interestAreasById: { [id: string]: InterestArea } = {};
    const parentSessionsById: { [id: string]: ParentSession } = {};
    const sessionsById: { [id: string]: Session } = {};
    const studiesById: { [id: string]: Study } = {};
    const studyTypesById: { [id: string]: StudyType } = {};
    const studyFormsById: { [id: string]: StudyForm } = {};
    const subjectsById: { [id: string]: Subject } = {};
    const studyLanguagesById: { [id: string]: StudyLanguage } = {};
    const selectedSessions: string[] = [];
    const allFilteredSessions: Session[] = [];
    const recievedSessions: Session[] = [];
    const recievedParentSessions: ParentSession[] = [];
    let choossenGroepsGrootte: number = 0;

    //let fetchUrl = `./api/GetEventRegistrationData/?id=${eventId}&max=${input.max}`;
    let fetchUrl = `./api/${eventId}.json?` + moment(new Date()).format("yyyyMMddhhmmssSSSS").toString();

    if (input.ppId) {
      const ppResponse = await fetch(
        `./api/GetPortalProcessingData/?id=${input.ppId}`
      );
      const ppData: PortalProcessing = await ppResponse.json();
      portalProcessing = ppData;
      eventId = portalProcessing.eventId;
      fetchUrl = `./api/${eventId}.json?` + moment(new Date()).format("yyyyMMddhhmmssSSSS").toString();
      choossenGroepsGrootte = portalProcessing.groepsgrootte;
    }

    // Get the session data
    const response = await fetch(
      fetchUrl
    );

    if (response.status != 200) {
      switch (response.status) {
        case 404:
          return {
            loadingSessions: true,
            SessionsFullyLoaded: false,
            loadingError: true,
            loadingMessage: "NOSESSIONFILE"
          };
          break;
        default:
          break;
      }

    }

    const {
      event,
      parentsessions,
      data
    }: {
      event: Event;
      parentsessions: ParentSession[];
      data: Session[];
    } = await response.json();

    parentsessions.forEach(p => recievedParentSessions.push(p));
    data.forEach(session => recievedSessions.push(session));

    recievedParentSessions.forEach(parentSession => {
      if (!parentSession.sortOrder)
        parentSession.sortOrder = "1000";
      else
        parentSession.sortOrder = parentSession.sortOrder.padStart(4, "0");

      if (parentSession && parentSession.id && !parentSessionsById[parentSession.id]) {
        parentSessions.push(parentSession);
        filterdParentSessions.push(parentSession);
        parentSessionsById[parentSession.id] = parentSession;
      }
      if (parentSession && parentSession.id) {
        if (parentSession.nederlands == "true") {
          if (!studyLanguagesById["Nederlands"]) {
            studyLanguages.push({
              id: "Nederlands",
              count: 1,
              name: "Nederlands"
            });
            studyLanguagesById["Nederlands"] = {
              id: "Nederlands",
              count: 1,
              name: "Nederlands"
            };
          } else {
            const s = studyLanguages.find(item => item.id === "Nederlands");
            if (s != null) s.count++;
          }
        }

        if (parentSession.duits == "true") {
          if (!studyLanguagesById["Duits"]) {
            studyLanguages.push({ id: "Duits", count: 1, name: "Duits" });
            studyLanguagesById["Duits"] = {
              id: "Duits",
              count: 1,
              name: "Duits"
            };
          } else {
            const s = studyLanguages.find(item => item.id === "Duits");
            if (s != null) s.count++;
          }
        }
        if (parentSession.engels == "true") {
          if (!studyLanguagesById["Engels"]) {
            studyLanguages.push({ id: "Engels", count: 1, name: "Engels" });
            studyLanguagesById["Engels"] = {
              id: "Engels",
              count: 1,
              name: "Engels"
            };
          } else {
            const s = studyLanguages.find(item => item.id === "Engels");
            if (s != null) s.count++;
          }
        }
      }
    });


    //Haal capaciteit op en verwerk dit in de sessies
    const capaciteitFetch = await fetch(
      `./api/GetSessionCapacityData/?id=${eventId}&` + moment(new Date()).format("yyyyMMddhhmmssSSSS").toString()
    );
    const {
      capaciteit
    }: {
      capaciteit: Session[];
    } = await capaciteitFetch.json();

    recievedSessions.forEach(session => {
      const s = capaciteit.find(s => s.id == session.id);
      if (s) {
        session.start = s.start;
        session.end = s.end;
        session.maxCapacity = s.maxCapacity;
        session.registrationCount = s.registrationCount;
        session.sluitdatumtijd = s.sluitdatumtijd;
      }
    });

    // Copy data from hoofdsessie naar deelsessie
    recievedSessions.filter(s => s.sessionType).forEach(session => {
      const mainSession = recievedSessions.find(s => s.id == session.mainSession);
      if (mainSession) {
        session.building = mainSession.building;
        session.start = mainSession.start;
        session.end = mainSession.end;
        session.maxCapacity = mainSession.maxCapacity;
        session.registrationCount = mainSession.registrationCount;
        //session.audience = mainSession.audience;
        session.sluitdatumtijd = mainSession.sluitdatumtijd;
        session.withoutDate = mainSession.withoutDate;

      }
    });

    recievedSessions.forEach(session => {
      const {
        parentSession,
        study,
        interestArea,
        audience,
        building,
        studytype,
        studyform,
        subject
      } = session;

      if (session.id) {

        let isValid = true;

        if (session.sluitdatumtijd) {
          const sluitdatumtijd = new Date(session.sluitdatumtijd);
          isValid = moment().isBefore(moment(sluitdatumtijd));
        }

        if (session.start && session.end && isValid) {
          const startdatumtijd = new Date(session.start);
          const einddatumtijd = new Date(session.end);
          isValid = moment().isSameOrBefore(moment(startdatumtijd));

          // als einddatumtijd vandaag is, dan is het ook nog geldig
          if (!isValid && moment().isSame(moment(einddatumtijd), 'day')) {
            isValid = moment().isSameOrBefore(moment(einddatumtijd));
          }
        }

        if (portalProcessing) {
          if (portalProcessing.sessieGuids.includes(session.id)) {
            if (!isValid) {
              const index = portalProcessing.sessieGuids.indexOf(session.id, 0);
              if (index > -1) {
                portalProcessing.sessieGuids.splice(index, 1);
              }
            }
          }
        }

        if (!session.name) {
          if (!sessionsById[session.id]) {
            isValid = false;
          }
        }

        if (isValid) {

          if (parentSession) {
            session.parentSession = parentSessionsById[parentSession.id];
          }

          session.interestAreas = [];
          if (!sessionsById[session.id]) {
            if (interestArea) {
              session.interestAreas.push(interestArea);
              if (!interestAreasById[interestArea.id]) {
                interestArea.count = 1;
                interestAreas.push(interestArea);
                interestAreasById[interestArea.id] = interestArea;
              } else {
                const ia = interestAreas.find(item => item.id === interestArea.id);
                if (ia != null) ia.count++;
              }
            }

            allFilteredSessions.push(session);
            sessions.push(session);
            sessionsById[session.id] = session;

            if (building) {
              if (building.name.length == 0) {
                building.name = "";
                building.id = "empty";
              }

              if (!buildingsById[building.id]) {
                building.count = 1;
                buildings.push(building);
                buildingsById[building.id] = building;
              } else {
                const b = buildings.find(item => item.id === building.id);
                if (b != null) b.count++;
              }
            }

            if (study) {
              if (!studiesById[study.id]) {
                study.count = 1;
                studies.push(study);
                studiesById[study.id] = study;
              } else {
                const s = studies.find(item => item.id === study.id);
                if (s != null) s.count++;
              }
            }

            if (studytype) {
              if (!studyTypesById[studytype.id]) {
                studyTypes.push(studytype);
                studyTypesById[studytype.id] = studytype;
              } else {
                const st = studyTypes.find(item => item.id === studytype.id);
                if (st != null) st.count++;
              }
            }

            if (studyform) {
              if (!studyFormsById[studyform.id]) {
                studyForms.push(studyform);
                studyFormsById[studyform.id] = studyform;
              } else {
                const st = studyForms.find(item => item.id === studyform.id);
                if (st != null) st.count++;
              }
            }

            if (subject) {
              if (!subjectsById[subject.id]) {
                subjects.push(subject);
                subjectsById[subject.id] = subject;
              } else {
                const st = subjects.find(item => item.id === subject.id);
                if (st != null) st.count++;
              }
            }

            if (audience) {
              if (!audiencesById[audience.id]) {
                audiences.push(audience);
                audiencesById[audience.id] = audience;
              } else {
                const au = audiences.find(item => item.id === audience.id);
                if (au != null) au.count++;
              }
            }

            if (!session.withoutDate) {
              const sessionStartDate = new Date(session.start);
              const dateId = sessiondate_helper.CalcDateID(sessionStartDate, this.event.eventtype);
              if (!dateOfSessionsById[dateId]) {
                dateOfSessions.push({
                  id: dateId,
                  count: 1,
                  value: sessionStartDate,
                  formatted: sessiondate_helper.FormatDate(sessionStartDate, this.event.eventtype)
                });
                dateOfSessionsById[dateId] = {
                  id: dateId,
                  count: 1,
                  value: sessionStartDate,
                  formatted: sessiondate_helper.FormatDate(sessionStartDate, this.event.eventtype)
                };
              } else {
                const dos = dateOfSessions.find(item => item.id === dateId);
                if (dos != null) dos.count++;
              }
            }
            else {
              const dateId = 100000000;
              if (!dateOfSessionsById[dateId]) {

                const formatted = input.language == "nl" ? "Er is nog geen datum en tijd bekend" : "Date and time not set yet";

                dateOfSessions.push({
                  id: dateId,
                  count: 1,
                  value: new Date("1-1-1900"),
                  formatted: formatted
                });
                dateOfSessionsById[dateId] = {
                  id: dateId,
                  count: 1,
                  value: new Date("1-1-1900"),
                  formatted: formatted
                };
              } else {
                const dos = dateOfSessions.find(item => item.id === dateId);
                if (dos != null) dos.count++;
              }
            }
          } else {
            if (interestArea) {
              const sessie = sessions.find(item => item.id === session.id);
              sessie?.interestAreas?.push(interestArea);

              if (!interestAreasById[interestArea.id]) {
                interestArea.count = 1;
                interestAreas.push(interestArea);
                interestAreasById[interestArea.id] = interestArea;
              } else {
                const ia = interestAreas.find(item => item.id === interestArea.id);
                if (ia != null) ia.count++;
              }
            }
          }
        }
      }
    });

    if (portalProcessing) {
      for (
        let index = 0;
        index < portalProcessing.sessieGuids.length;
        index++
      ) {
        const sessieId = portalProcessing.sessieGuids[index];
        if (sessionsById[sessieId]) {
          selectedSessions.push(sessieId);
        }
      }
    }

    filterdParentSessions.sort((a, b) => {
      const aConcat = a.sortOrder + a.name;
      const bConcat = b.sortOrder + b.name;

      if (aConcat > bConcat) {
        return 1;
      } else if (aConcat < bConcat) {
        return -1;
      } else {
        return 0;
      }
    });

    return {
      loadingSessions: false,
      SessionsFullyLoaded: true,
      portalProcessing,
      loadingError: false,
      loadingMessage: "",
      audiences,
      buildings,
      interestAreas,
      parentSessions,
      filterdParentSessions,
      sessions,
      studies,
      studyTypes,
      studyForms,
      subjects,
      studyLanguages,
      dateOfSessions,
      audiencesById,
      buildingsById,
      interestAreasById,
      parentSessionsById,
      sessionsById,
      studiesById,
      studyTypesById,
      studyFormsById,
      subjectsById,
      studyLanguagesById,
      selectedSessions,
      allFilteredSessions,
      choossenGroepsGrootte
    };
  }
}
